import * as React from 'react';
import { useSelector } from 'react-redux';

import logger from 'lib/logger';
import { ApplicationState } from 'store/store';
import { reviewsApi } from '../reviewsApi';
import { IReview } from '../model/Review';

export const useReviews = (orderId?: number) => {
    const [review, setReview] = React.useState<IReview | null>(null);
    const [loading, setLoading] = React.useState(true);

    const { settings } = useSelector((state: ApplicationState) => state.settings);
    const reviewsEnabled = React.useMemo(
        () => !!(settings?.reviewsEnabled && settings?.reviewsEnabledByMerchant),
        [settings]
    );

    React.useEffect(() => {
        const getReviews = async (orderId: number) => {
            setLoading(true);
            try {
                const reviews = await reviewsApi.getReviews(orderId);
                // Technically we could have multiple reviews for an order, but we'll only show the most recent one
                if (reviews.items.length > 0) {
                    setReview(reviews.items[0]);
                }
            } catch (error) {
                logger.error('Error fetching reviews', error);
            } finally {
                setLoading(false);
            }
        };

        if (!!orderId && reviewsEnabled) {
            getReviews(orderId);
        }
    }, [orderId, reviewsEnabled]);

    return { review, loading, reviewsEnabled };
};
